import React, { useEffect, useState } from 'react';
const isDev = process.env.REACT_APP_IS_DEV === 'true';

const ServerHealthChecker: React.FC = () => {
  const [failCount, setFailCount] = useState(0);
  const [disconnected, setDisconnected] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      /*
      if(!isDev){
        fetch('/api/v1/common/health') // 💡 실제 API 주소 사용
        .then((res) => {
          if (!res.ok) throw new Error('Status not OK');
          return res.text();
        })
        .then(() => {
          setFailCount(0); // 성공하면 실패 횟수 초기화
        })
        .catch(() => {
          setFailCount((prev) => {
            const next = prev + 1;
            //if (next >= 5) setDisconnected(true); // 5회 이상 실패 시 모달 표시
            return next;
          });
        });
      }
      */
      
    }, 5000); // 1초마다 체크

    return () => clearInterval(interval); // cleanup
  }, []);

  return (
    <>
      {disconnected && (
        <div style={modalStyle}>
          <div style={modalContentStyle}>
            <h2>서버와의 연결이 끊겼습니다.</h2>
          </div>
        </div>
      )}
    </>
  );
};

// 💡 간단한 스타일 예시
const modalStyle: React.CSSProperties = {
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100vw',
  height: '100vh',
  backgroundColor: 'rgba(0, 0, 0, 0.7)',
  zIndex: 9999,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

const modalContentStyle: React.CSSProperties = {
  backgroundColor: 'white',
  padding: '40px',
  borderRadius: '12px',
  fontSize: '1.2rem',
};

export default ServerHealthChecker;
